<script>
    import moment from 'moment';
    import {sgettext} from '../../../i18n.js';

    export let row = {};

    let dayLabel = 'day';
    let age = 0;

    $: getAge(row);

    function getAge(row){
        const today = moment();
        if(today.isSame(moment(row.created_date), 'day')){
            dayLabel = sgettext('$$TODAY$$');
        } else {
            age = Math.ceil(moment.duration(today.diff(moment(row.created_date))).asDays());
            dayLabel = `${age} ${age > 1 ? sgettext('$$DAYS$$') : sgettext('$$DAY$$')}`;
        }
    }
</script>

{dayLabel}